module.exports = __webpack_public_path__ + "./assets/icons/stretching-cheval-equitation.jpg";